import { render, staticRenderFns } from "./BridgeDataList.vue?vue&type=template&id=3bb5f683&scoped=true"
import script from "./BridgeDataList.vue?vue&type=script&lang=js"
export * from "./BridgeDataList.vue?vue&type=script&lang=js"
import style0 from "./BridgeDataList.vue?vue&type=style&index=0&id=3bb5f683&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb5f683",
  null
  
)

export default component.exports